import { render } from "./MfpPopup.vue?vue&type=template&id=0d5a34a7&scoped=true"
import script from "./MfpPopup.vue?vue&type=script&lang=js"
export * from "./MfpPopup.vue?vue&type=script&lang=js"

import "./MfpPopup.vue?vue&type=style&index=0&id=0d5a34a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5a34a7"]])

export default __exports__